<template>
  <div>
    <div class="row">
      <div class="col-12 text-right">
        <button id="header-close-btn" aria-label="Close" class="close my-2 d-none d-sm-block" type="button">
          <svg class="icon">
            <use xlink:href="/assets/img/icon-sprite.svg#global.close" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
          </svg>
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <!-- for touch devices-->
        <form class="nav language d-block d-lg-none">
          <div v-for="(country, index) in countries" class="form-row justify-content-center">
            <div class="form-group col-6 text-center">
              <label class="col-form-label col-form-label-sm" for="country">Land</label>
              <select class="form-control custom-select" name="country" required>
                <option :value="country.code" selected>{{ country.code.toUpperCase() }}</option>
                <option v-for="(language, langIndex) in country.languages" :value="language">
                  {{ language.code.toUpperCase() }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-row justify-content-center">
            <div class="form-group col-6 text-center">
              <button class="btn btn-primary btn-block border-0" type="submit">Speichern</button>
            </div>
          </div>
        </form>
        <!-- for desktop-->
        <ul class="nav language justify-content-center d-none d-lg-flex">
          <li v-for="(country, index) in countries" class="nav-item text-center ml-2 ml-md-5">
						<span :data-country="country.code" class="nav-link" role="button">
							<ul :class="'sub-nav-count-' + country.languages.length" class="nav sub-nav position-absolute">
								<li v-for="(language, langIndex) in country.languages" class="nav-item">
									<a :data-country="country.code" :data-language="language.code" class="nav-link" role="button"
                     @click="setLanguage(country, language)">
										<div class="flag-item">
											<svg class="icon icon-sm" role="img">
												<title>{{ language.code.toUpperCase() }}</title>
												<use :xlink:href="'/assets/img/icon-sprite.svg#country.' + language.code"
                             xmlns:xlink="http://www.w3.org/1999/xlink"></use>
											</svg>
										</div>
									</a>
								</li>
							</ul>
							<div class="flag-item">
								<svg class="icon icon-lg" role="img">
									<title>{{ country.code.toUpperCase() }}</title>
									<use :xlink:href="'/assets/img/icon-sprite.svg#country.' + country.code"
                       xmlns:xlink="http://www.w3.org/1999/xlink"></use>
								</svg>
							</div>
							<p class="mt-2 text-uppercase">{{ __(country.countryKey).toUpperCase() }}</p>
						</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      countries: [
        {
          code: 'de',
          id: 276,
          languages: [
            {id: 3, code: 'fr', path: '/fr'},
            {id: 2, code: 'uk', path: '/en'},
            {id: 1, code: 'de', path: '/de'}
          ],
          countryKey: 'lang.country.de'
        },
      ],
    }
  },
  methods: {
    setLanguage(country, language) {
      this.userCountry = {
        language_code: language.code,
        language_id: language.id,
        country_code: country.code,
        country_id: country.id,
      }

      window.location.href = language.path;
    }
  },
  computed: {
    userCountry: {
      get() {
        return this.$store.state.User.country
      },
      set(value) {
        this.$store.commit('User/updateCountry', value)
      }
    },
  },
  created() {
    // check if url path is equal to selected language path
    // if not, store url path in local storage
    // if url path not in countires[0].languages, redirect to de path
    const path = window.location.pathname
    const storedPath = this.countries.find(country => country.code === this.userCountry.country_code).languages.find(language => language.code === this.userCountry.language_code).path

    // if no stored path, set default language
    if (!storedPath) {
      this.setLanguage(this.countries[0], this.countries[0].languages[2])
    }

    // if stored path is not equal to url path, check if url path is in languages then set language or redirect to default language
    if (path === storedPath) {
      return
    }

    if (this.countries.some(country => country.languages.some(language => language.path === path))) {
      const country = this.countries.find(country => country.languages.some(language => language.path === path))
      const language = country.languages.find(language => language.path === path)
      this.setLanguage(country, language)
      return
    }

    this.setLanguage(this.countries[0], this.countries[0].languages[2])
  }
}
</script>
